<template>
    <div id="seccion">
        <div id="encabezados-tp">
            <h1>Registro de audiencia</h1>
            <h3>crea la programación de la audiencia</h3>
        </div>
        <div class="d-flex justify-content-center margen-main-GT">
            <div id="alert-cambios-guardados" style="margin-top: -2em;" class="alert alert-success d-none col-3" role="alert">
                <div class="d-flex align-items-center">
                    <div class="mr-4">
                        <i style="font-size: 2em;" class="fas fa-check-circle"></i>
                    </div>
                    <div>
                        Los cambios de guardaron de manera correcta
                    </div>
                </div>
            </div>
        </div>
        <div id="seccion-formulario-creacion-VPDA" class="row margen-main-GT">
            <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 pr-4" id="contendor-formulario">
                <div class="card">
                    <div class="card-header">
                        <div class="form-inline justify-content-between flex-wrap">
                            <h5 class="form-inline">
                                <strong>FORMULARIO DE REGISTRO</strong>&nbsp;&nbsp;
                            </h5>
                        </div>
                    </div>
                    <div class="card-body">
                        <CFormularioProgramacionAudiencia
                            :idElemento="ALTA.ID_ELEMENTO"
                            :esParaEdicion="ALTA.esParaEdicion"
                            :jueces="CATALOGOS.tiposJuez"
                            :zoom="CATALOGOS.tiposZoom"
                            :tiposAudiencia="CATALOGOS.tiposAudiencias"
                            :detenidos="CATALOGOS.tiposDetenido"
                            :partidosJudiciales="CATALOGOS.partidoJudicial"
                            :audiencias="CATALOGOS.audiencias"
                            v-on:GetDatosFormulario="getDatosFormularioAlta"
                            v-on:actualizarAgenda="evtActaulizarTablaDeAgendaFormulario"
                            :key="ALTA.KEY + ALTA.contRender"
                            :ref="ALTA.REF"
                        ></CFormularioProgramacionAudiencia>
                    </div>
                </div>
            </div>
            <div class="col-xs-7 col-sm-7 col-md-7 col-lg-7 pr-2">
                <div class="tabla-audiencias-VPA">
                    <div id="toolbar-tabla-agenda-formVPDA">
                        <h4>Agenda</h4>
                    </div>
                    <table
                        class="table table-light table-hover"
                        :id="ALTA.TABLA.ID"              
                        data-toggle="table"
                        data-pagination="true"
                        data-toolbar="#toolbar-tabla-agenda-formVPDA"
                        data-undefined-text="Sin información" 
                        data-maintain-meta-data="true"
                        data-click-to-select="false"
                        data-page-size = "30"
                        data-page-list="[10,20,30, 40, 50, 60, 70, 80, 90, 100]"
                        data-show-toggle="false"
                        data-show-pagination-switch="true"
                        data-row-style="aplicarEstilosPorPartidoJudicial"
                        data-search="true">
                        <thead class="thead-dark">
                            <tr>
                                <th data-halign="center" data-width="10" data-align="center" data-field="partido" data-sortable="true">
                                    PARTIDO
                                </th>
                                <th data-halign="center" data-width="38" data-align="center" data-field="carpeta" data-sortable="true">
                                    CARPETA
                                </th>
                                <th data-halign="center" data-width="15" data-align="center" data-field="hora" data-sortable="true">
                                    HORA
                                </th>
                                <th data-halign="center" data-width="10" data-align="center" data-field="audiencia" data-sortable="true">
                                    AUDIENCIA
                                </th>
                                <th data-halign="center" data-width="6" data-align="center" data-field="juez" data-sortable="true">
                                    JUEZ
                                </th>
                            </tr>
                        </thead>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { campoEsValido } from "../../SINOJ/Comun/Funciones/validaciones.js"
import { inicializarTabla } from "../Programacion/Funciones/Tablas.js"
import CFormularioProgramacionAudiencia from "../Programacion/Comun/CFormularioProgramacionAudiencia.vue"
import { servicioRestPost } from '../Programacion/servicios/ServiciosHttp.js'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api';
import moment from 'moment'
import { CATALOGOS } from '../Catalogos/CatalogosBD.js'

export default {
    components: {
        CFormularioProgramacionAudiencia: CFormularioProgramacionAudiencia
    },
    data() {
        return {
            CATALOGOS,
            ALTA: {
                ID_ELEMENTO: 'ID_FORMULARIO_ALTA_PA',
                esParaEdicion: false,
                datosFormulario: null,
                KEY: 'K_FORMULARIO_ALTA_PA',
                REF: 'R_FORMULARIO_ALTA_PA',
                contRender: 0,
                mostrarSeccionFormulario: false,
                TABLA: {
                    ID: 'Id-tablaAgendaJuez-PA',
                    lista: [],
                },
            },
        }
    },
    methods: {
        getDatosFormularioAlta: function(datos) {
            this.ALTA.datosFormulario = datos;
            this.ejecutarProcesoGuardarProgramacionesAudiencias({ conLoading: true });
        },
        ejecutarProcesoGuardarProgramacionesAudiencias: async function({ conLoading }) {
            if(conLoading)
                comun.SeEstaCargandoInformacion(true);
            try {
                const PETICION_GUARDAR_PROGRAMACIONES = await Promise.resolve(this.getPeticionGuardarProgramacion());
                const { CON_ERROR, RESPUESTA: { AudienciasProgramadas } }  = await Promise.resolve(servicioRestPost({
                    servicioUrl: api.GestionAudiencias.sistema.programacionAudiencias.programacion.GuardarProgramacionDeAudiencias,
                    peticionServicio: PETICION_GUARDAR_PROGRAMACIONES,
                    headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
                }));

                if(!CON_ERROR && AudienciasProgramadas != null && AudienciasProgramadas != undefined) {
                    if(AudienciasProgramadas.length > 0) {
                        this.ALTA.contRender ++;
                        this.ALTA.datosFormulario;
                        this.ALTA.mostrarSeccionFormulario = false;
                        this.ALTA.TABLA.lista = [];
                        await Promise.resolve(inicializarTabla({ idReferencia: this.ALTA.TABLA.ID, elementos: this.ALTA.TABLA.lista }));
                        this.$nextTick(() => {
                            $('html, body').animate({ scrollTop:0 }, 'slow'); 
                            $('#alert-cambios-guardados').removeClass('d-none');
                            setTimeout(() => {
                                $('#alert-cambios-guardados').addClass('d-none');
                            }, 1000);
                        });   
                    }
                }

                if(conLoading)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(e) {
                if(conLoading)
                    comun.SeEstaCargandoInformacion(false);
                console.error(e);
            }
        },
        getPeticionGuardarProgramacion: async function() { 
            let peticionAPI = { EsPrueba: false, Programaciones: [] };
            const { fechaAudiencia, juez, zoomId, partidoJudicial, 
                    horaAudiencia, tipoDeCarpeta, carpeta, carpetaA, 
                    tipoAudienciaId, detenidoId, fechaAudienciaConHora, 
                    juezDos, juezTres, audiencia, nombreEvento, fechaTerminoEvento } = this.ALTA.datosFormulario;
            peticionAPI.Programaciones.push({
                id: -1,
                fechaAudiencia: fechaAudienciaConHora,
                partidoJudicial: partidoJudicial,
                carpeta: (campoEsValido({ campoAValidar: carpeta }) && campoEsValido({ campoAValidar: carpetaA })) ? `${ carpeta }/${ carpetaA }` : 'Evento',
                tipoCarpeta: tipoDeCarpeta,
                hora: null,
                sala: null,
                modo: null,
                zoom: zoomId,
                audiencia: campoEsValido({ campoAValidar: tipoAudienciaId }) ? tipoAudienciaId : nombreEvento,
                detenido: detenidoId,
                auxiliar: null,
                juez: juez,
                pantalla: (campoEsValido({ campoAValidar: tipoAudienciaId }) && tipoAudienciaId.trim() == 'Audiencia Vía Telefónica') ? 0 : 1,
                estado: null,
                audienciaEliminada: 0,
                juezDos: juezDos,
                juezTres: juezTres,
                esAudiencia: audiencia,
                nombreEvento: nombreEvento,
                fechaTerminoEvento: fechaTerminoEvento
            });
            return peticionAPI;
        },
        evtActaulizarTablaDeAgendaFormulario: async function(filtros) {
            this.ejecutarProcesoGetAudienciasPorJuez({ conLoading: true, filtrosPeticion: filtros });
        },
        ejecutarProcesoGetAudienciasPorJuez: async function({ conLoading, filtrosPeticion }) {
            if(conLoading)
                comun.SeEstaCargandoInformacion(true);
            try {
                const PETICION_GET_AUDIENCIAS = { 
                    EsPrueba: false, 
                    FechaDeAudiencia: campoEsValido({ campoAValidar: filtrosPeticion.fecha }) ? filtrosPeticion.fecha : null,
                    Juez: campoEsValido({ campoAValidar: filtrosPeticion.juez }) ? filtrosPeticion.juez : null
                }
                const { CON_ERROR, RESPUESTA: { Audiencias } }  = await Promise.resolve(servicioRestPost({
                    servicioUrl: api.GestionAudiencias.sistema.programacionAudiencias.programacion.ObtenerAudienciasDeJuez,
                    peticionServicio: PETICION_GET_AUDIENCIAS,
                    headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
                }));

                if(!CON_ERROR) {
                   // console.log('Audiencias juez::', Audiencias);
                    this.ALTA.TABLA.lista = campoEsValido({ campoAValidar: Audiencias })
                        ? Audiencias.map(aDB => {
                            let audienciaObj = { ...aDB };
                            let nombreAudiencia = CATALOGOS.tiposAudiencias.find(ta => ta.llave == audienciaObj.audiencia);
                            audienciaObj.audiencia = campoEsValido({ campoAValidar: nombreAudiencia }) ? nombreAudiencia.valor : audienciaObj.audiencia;
                            audienciaObj.hora = moment(audienciaObj.fecha).format('hh:mm A');
                            audienciaObj.carpeta = !campoEsValido({ campoAValidar: audienciaObj.carpeta }) || (audienciaObj.carpeta.includes('null') || audienciaObj.carpeta.includes('NULL')) ? 'Evento' : audienciaObj.carpeta;
                            return audienciaObj;
                        })
                        : [];
                    await Promise.resolve(inicializarTabla({ idReferencia: this.ALTA.TABLA.ID, elementos: this.ALTA.TABLA.lista }));
                }

                if(conLoading)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(e) {
                if(conLoading)
                    comun.SeEstaCargandoInformacion(false);
                console.error(e);
            }
        }
    }
}
</script>
<style scoped>
.margen-main-GT {
    padding: 0 3em 0 2em;
}

/* ========== TITULOS ============== */
#encabezados-tp {
    margin-bottom: 4em;
    width: 100%;
    text-align: center;
    background-color: rgb(20, 20, 20);
    padding: 1em 0 0.5em 0;
}

#encabezados-tp h1 {
    margin-bottom: 0;
    font-weight: bold;
    font-size: 2.5em;
}

#encabezados-tp h3 {
    font-size: 1.5em;
    color: rgb(175, 175, 175);
}

#encabezados-tp h4 {
    font-size: 1.5em;
    color: rgb(214, 214, 214);
}

.hr-titulo {
    height:0.5em;
    width: 6em;
    border:none;
    background-color:#ffffff;
}

/* ========= SECCIONES  ========== */
#contendor-formulario .card-body {
    background-color: #323335;
}

#contendor-formulario .card {
    border: 1px solid rgb(129, 129, 129) !important;
}

#contendor-formulario .card-header {
    background-color: rgb(80, 80, 80);
}
</style>
<style>
@media (max-width: 1240px) {
    .tabla-audiencias-VPA td, .tabla-audiencias-VPA th {
        font-size: 0.77em !important;
    }

    .tabla-audiencias-VPA .form-control {
        width: 10em !important;
    }
}

/* .btn-firmantes-VFDD {
    color: #fff;
    background-color: #212529;
    border-color: #212529;
} */
.tabla-audiencias-VPA {
    padding-bottom: 2em;
    padding-right: 1em;
}

.tabla-audiencias-VPA .btn-sm {
    font-size: .9em !important;
}

.tabla-audiencias-VPA .btn-secondary {
    width: 2.5rem;
    background-color: #1f1f21;
    color: white;
    padding: 0.3em 0.3em 0.3em 0.3em;
    box-shadow: none;
}

.tabla-audiencias-VPA .form-control {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    height: 2.5em;
    width: 40vmin;
}

.tabla-audiencias-VPA .inputs-sm-edicion-VPA {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    width: 6.7em;
    font-size: 1em;
}

.tabla-audiencias-VPA .inputs-xs-edicion-VPA {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    width: 5.5em;
    font-size: 1em;
}

.tabla-audiencias-VPA .inputs-md-edicion-VPA {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    width: 10em;
    font-size: 1em;
}

.tabla-audiencias-VPA .inputs-lg-edicion-VPA {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    width: 14em;
    font-size: 1em;
}

/* .tabla-audiencias-VPA td {
    background-color: rgb(223, 223, 223);
    vertical-align: middle;
    font-weight: bold;
} */

.tabla-audiencias-VPA .borderless td, .tabla-audiencias-VPA .borderless th {
    border: none;
    border-bottom: 1px solid #d8d7d7 !important;
}

.tabla-audiencias-VPA td {
    border: none !important;
    font-size: 1.3em !important;
}

.tabla-audiencias-VPA th {
    font-size: 1.2em !important;
}

.tabla-audiencias-VPA .btn-light {
    background-color: white;
    border: 1px solid #4F4949;
    color: #AF9C9C;
    font-size: 1em;
}


.tabla-audiencias-VPA .btn-edt-cont-intr:hover, .tabla-audiencias-VPA .btn-edt-cont-intr:focus {
    background-color: #009bca;
    border: 1px solid #009bca;
    color: white;
}

.tabla-audiencias-VPA .btn-rmv-cont-intr:hover, .tabla-audiencias-VPA .btn-rmv-cont-intr:focus {
    background-color: #810000;
    border: 1px solid #810000;
    color: white;
}

.tabla-audiencias-VPA table {
    /* table-layout: fixed;
    width: 100%;
    word-wrap:break-word;  */
}

.tabla-audiencias-VPA .dropdown-toggle {
    width: 3.3rem;
    background-color: #1f1f21;
    color: white;
}

.tabla-audiencias-VPA .pagination > li > a {
    background-color: white;
    color: #121213;
}

.tabla-audiencias-VPA .pagination > .active > a {
    color: white;
    background-color:  #1f1f21;
    border: solid 1px #676666;
}

.tabla-audiencias-VPA > .active > a:hover {
    background-color:  #21211f;
    border: solid 1px #676666;
} 

</style>


// WEBPACK FOOTER //
// src/components/Audiencias/Registro/CRegistroAudiencias.vue